import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidateList, updateJobStatus } from "./CandidateAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchCandidateListAsync = createAsyncThunk(
  "Candidates/fetch",
  async ({ page, status }, { rejectWithValue }) => {  // Accepting both page & status
    try {
      const data = await fetchCandidateList(page, status); // Passing status to fetchCandidateList

      if (!data || !data.response || !data.response.records) {
        throw new Error("Invalid API response");
      }

      const resp = data.response;
      // console.log("data.response Slice", resp.records);

      return {
        candidates: resp, // Returning the candidate list
        totalCandidates: resp.records.length, // Returning the count of candidates
      };
    } catch (error) {
      console.error("Fetch failed:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const updateJobStatusAsync = createAsyncThunk(
  "Candidates/add",
  async ({ uuid, newStatus}) => {
    try {
      const data = await updateJobStatus(uuid, newStatus);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      return error
      // return rejectWithValue(error.message);
    }
  }
);

const CandidateListSlice = createSlice({
  name: "Candidates",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCandidateListAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCandidateListAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchCandidateListAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(updateJobStatusAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(updateJobStatusAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to add ";
      })
  },
});

export const selectCandidates = (state) => state.candidateList.data.candidates;
export const selectCandidatesTotal = (state) => state.candidateList.data;

export default CandidateListSlice.reducer;
